import { Role, RolePermission } from '../../../../../../../helpers/permissions';
import { RolePermissionGroupPreprocessedProps, RoleTabsPreprocessedProps } from './types';

export const PERMISSIONS_PREPROCESSED_GROUPS: RolePermissionGroupPreprocessedProps[] = [
    {
        labelKey: 'permissions-group-camera',
        permissions: [
            {
                labelKey: 'role-permission-camera',
                permission: RolePermission.CAMERA,
            },
            {
                labelKey: 'role-permission-camera-mute',
                permission: RolePermission.CAMERA_MUTE,
            },
        ],
    },
    {
        labelKey: 'permissions-group-microphone',
        permissions: [
            {
                labelKey: 'role-permission-microphone',
                permission: RolePermission.MICROPHONE,
            },
            {
                labelKey: 'role-permission-microphone-mute',
                permission: RolePermission.MICROPHONE_MUTE,
            },
        ],
    },
    {
        labelKey: 'permissions-group-desktop',
        permissions: [
            {
                labelKey: 'role-permission-desktop',
                permission: RolePermission.DESKTOP,
            },
            {
                labelKey: 'role-permission-desktop-mute',
                permission: RolePermission.DESKTOP_MUTE,
            },
        ],
    },
    {
        labelKey: 'permissions-group-recording',
        permissions: [
            {
                labelKey: 'role-permission-recording',
                permission: RolePermission.RECORDING,
            },
            {
                labelKey: 'role-permission-recording-mute',
                permission: RolePermission.RECORDING_MUTE,
            },
        ],
    },
    {
        labelKey: 'permissions-group-cloud-recording',
        permissions: [
            {
                labelKey: 'role-permission-cloud-recording',
                permission: RolePermission.CLOUD_RECORDING,
            },
        ],
    },
    {
        labelKey: 'permissions-group-summarization-v2',
        permissions: [
            {
                labelKey: 'role-permission-summarization',
                permission: RolePermission.SUMMARIZATION,
            },
            {
                labelKey: 'role-permission-summarization-receive',
                permission: RolePermission.SUMMARIZATION_RECEIVE,
            },
            {
                labelKey: 'role-permission-calendar-summarization-receive',
                permission: RolePermission.CALENDAR_SUMMARIZATION_RECEIVE,
            },
        ],
    },
    {
        labelKey: 'permissions-group-waiting-room',
        permissions: [
            {
                labelKey: 'role-permission-access-level-edit',
                permission: RolePermission.ACCESS_LEVEL_EDIT,
            },
            {
                labelKey: 'role-permission-admit',
                permission: RolePermission.ADMIT,
            },
        ],
    },
    {
        labelKey: 'permissions-group-close-room',
        permissions: [
            {
                labelKey: 'role-permission-close-room',
                permission: RolePermission.CLOSE_ROOM,
            },
        ],
    },
    {
        labelKey: 'permissions-group-conference-permissions',
        permissions: [
            {
                labelKey: 'role-permission-conference-permissions-edit-matrix',
                permission: RolePermission.CONFERENCE_PERMISSIONS_EDIT_MATRIX,
            },
        ],
    },
];

export const ROLE_TABS_PROPS: RoleTabsPreprocessedProps[] = [
    {
        contentKey: 'role-tab-admin',
        id: Role.ADMIN,
    },
    {
        contentKey: 'role-tab-member',
        id: Role.MEMBER,
    },
];
